import React from 'react'
// import PropTypes from 'prop-types'
import BannerLogo from '../BannerLogo'
import './Footer.sass'
import Icon from '../Icon'
import Col from "../Col"
import Container from "../Container"

export default class Footer extends React.PureComponent {
  // static propTypes = {
  //   prefix: PropTypes.string,
  //   suffix: PropTypes.string
  // }

  render() {
    const {suffix, prefix} = this.props
    return (
      <footer className="footer-wrapper">
        <Container>
          <Col xs={6} sm={12} md={24} lg={24} >
            <div className="footer">
              <div className="footer__logo-gosuslugi-icon" >
                <Icon type='logo_gosuslugi' />
              </div>
              <p className="footer__logo-gosuslugi-text">
                Разработано в соответствии с <a href="http://guides.gosuslugi.ru/">правилами дизайна Единого портала Госуслуг</a>
              </p>
              <div className="session-new-footer-phone">
                <BannerLogo prefix={prefix} suffix={suffix} />
                <span className="session-new-footer-phone-item">2015-2018</span>
              </div>
              <div className="footer__logo-gosuslugi-icon--right" />
            </div>
          </Col>
        </Container>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./components/Footer/index.jsx